import { FileText } from 'lucide-react'
import {
  pickString,
  readToolState,
  ToolStatusLine,
  type ToolPartProps,
} from './_base'

export function ArtifactsSaveToolMessage({ part }: ToolPartProps) {
  const state = readToolState(part)
  return (
    <ToolStatusLine
      state={state}
      loadingLabel='Saving artifact...'
      completedLabel='Artifact saved'
      loadingDetail={pickString(state.args?.name)}
      completedDetail={pickString(state.args?.name, state.result?.name)}
      completedIcon={
        <FileText className='h-3.5 w-3.5 shrink-0 text-text-placeholder' />
      }
    />
  )
}
